import { render } from "./base-accordion.vue?vue&type=template&id=397b199c"
import script from "./base-accordion.vue?vue&type=script&lang=js"
export * from "./base-accordion.vue?vue&type=script&lang=js"

import "./base-accordion.vue?vue&type=style&index=0&id=397b199c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__